import { routerReducer } from 'react-router-redux';
import { combineReducers } from 'redux';
import { THEME_KEY } from '../theme/constants';
import { reducer as themeReducer } from '../theme/reducer';
import { AB_KEY } from '../ab/constants';
import { abReducer } from '../ab/reducer';
import { LOCATION_KEY } from '../location/constants';
import locationReducer from '../location/reducer';
import { PAGELOAD_KEY } from '../pageload/constants';
import { reducer as pageloadReducer } from '../pageload/reducer';
import { VIEWPORT_KEY } from '../viewport/constants';
import { viewportReducer } from '../viewport/reducer';

export default function createRootReducer(reducers = {}) {
    return combineReducers({
        routing: routerReducer,
        [THEME_KEY]: themeReducer,
        [AB_KEY]: abReducer,
        [LOCATION_KEY]: locationReducer,
        [PAGELOAD_KEY]: pageloadReducer,
        [VIEWPORT_KEY]: viewportReducer,
        ...reducers,
    });
}
